// src/utils/saveEvents.js
// All immediate save events - trigger save right away (button clicks)
export const IMMEDIATE_SAVE_EVENTS = [
  // Entity actions
  'entity_added',
  'entity_deleted', 
  'entity_form_submitted',
  
  // Relationship actions
  'relationship_added',
  'relationship_deleted',
  'relationship_form_submitted',
  
  // Specialization actions
  'specialization_added',
  'specialization_deleted',
  'specialization_form_submitted',
  
  // Union actions
  'union_added',
  'union_deleted',
  'union_form_submitted',
  
  // Global ERD actions
  'erd_generated',
  'sample_loaded',
  'work_loaded'
];

// All debounced save events - wait for user to stop before saving (typing only)
export const DEBOUNCED_SAVE_EVENTS = [
  // Text editing only
  'raw_notation_edited'
];

// Debounce delays for different event types (in milliseconds)
export const DEBOUNCE_DELAYS = {
  'raw_notation_edited': 2000,        // 2s for text area
  'default': 2000                     // Default 2s for any other debounced events
};

// Get debounce delay for a specific event type
export const getDebounceDelay = (eventType) => {
  return DEBOUNCE_DELAYS[eventType] || DEBOUNCE_DELAYS.default;
};

// Check if an event should trigger immediate save
export const isImmediateSave = (eventType) => {
  return IMMEDIATE_SAVE_EVENTS.includes(eventType);
};

// Check if an event should be debounced
export const isDebouncedSave = (eventType) => {
  return DEBOUNCED_SAVE_EVENTS.includes(eventType);
};

// Generate save event data with common fields
export const createSaveEventData = (eventType, customData = {}) => {
  return {
    eventType,
    timestamp: Date.now(),
    source: 'event_driven',
    ...customData
  };
};